import { useState, useEffect } from "react";
import { BREAKPOINTS } from "src/utils/viewport";

/**
 * Custom hook to detect if the viewport is mobile-sized
 * @param breakpoint - The max width in pixels to consider as mobile (default: 1024px for lg breakpoint)
 * @returns boolean indicating if the viewport is mobile-sized
 */
export const useIsMobile = (breakpoint: number = BREAKPOINTS.lg): boolean => {
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    // Check if window is defined (for SSR compatibility)
    if (typeof window === "undefined") {
      return;
    }

    // Function to check if viewport is mobile
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < breakpoint);
    };

    // Initial check
    checkIsMobile();

    // Add event listener for window resize
    window.addEventListener("resize", checkIsMobile);

    // Cleanup
    return () => {
      window.removeEventListener("resize", checkIsMobile);
    };
  }, [breakpoint]);

  return isMobile;
};
